// extracted by mini-css-extract-plugin
export default {"form":"b5051e2ea752","container":"eb9f44617809","input":"c653b932b957","submit":"eb5e78ed9abc","label":"a071031584ec","item":"f563cefa394c","highlight":"be51fc6be801"};